import { apiClient } from '@/api/client';
import type {
  ApiResponse,
  ListParams,
  Society,
  SocietyRegisterPayload,
  SocietyRegisterResult,
} from '@/types/api';

export class SocietyService {
  static async list(params?: ListParams) {
    const { data } = await apiClient.get<ApiResponse<Society[]>>('/societies', {
      params,
    });
    return data;
  }

  static async getById(id: string) {
    const { data } = await apiClient.get<ApiResponse<Society>>(`/societies/${id}`);
    return data;
  }

  static async register(payload: SocietyRegisterPayload) {
    const { data } = await apiClient.post<ApiResponse<SocietyRegisterResult>>(
      '/societies',
      payload,
    );
    return data;
  }

  static async update(id: string, payload: Partial<SocietyRegisterPayload>) {
    const { data } = await apiClient.put<ApiResponse<Society>>(
      `/societies/${id}`,
      payload,
    );
    return data;
  }

  static async uploadLogo(id: string, file: File) {
    const form = new FormData();
    form.append('logo', file);
    const { data } = await apiClient.patch<ApiResponse<Society>>(
      `/societies/${id}/logo`,
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return data;
  }

  static async getMyEntitlements() {
    const { data } = await apiClient.get<ApiResponse<{
      societyId: string;
      basePlanCode: string;
      basePlanName: string;
      displayLabel: string;
      hasAddons: boolean;
      hasCustomizations: boolean;
      activeAddonsCount: number;
      activeCustomizationsCount: number;
      features: Record<string, any>;
    }>>('/societies/my-society/entitlements');
    return data;
  }

  static async submitFeatureRequest(payload: {
    featureCode: string;
    reason?: string;
    requestType?: 'ADDON' | 'CUSTOMIZATION' | 'PLAN_UPGRADE';
    requestedBillingCycle?: 'MONTHLY' | 'QUARTERLY' | 'HALF_YEARLY' | 'YEARLY' | 'ONE_TIME';
    offeredPrice?: number;
    notes?: string;
  }) {
    const { data } = await apiClient.post<ApiResponse<any>>(
      '/societies/my-society/feature-requests',
      payload,
    );
    return data;
  }
}
